
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[...urlSlug]",
      function () {
        return require("private-next-pages/blog/[...urlSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[...urlSlug]"])
      });
    }
  